module.exports = __webpack_public_path__ + "img/mdh3.784ad216.jpg";